import * as React from 'react'
import {useNavigate} from 'react-router'
// CComponents
import {H1} from '@frontrow/console/src/components/typography'
import {Link} from '@frontrow/console/src/components/ui/link'
import {type StoreCategoryT} from '@frontrow/console/src/entities/models/item'
import {type StoreCategoryVariationT} from '@frontrow/console/src/entities/models/store-category-variation'

// Components
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import Form from './../form'
// Helpers
import {type ItemParamsT} from '@frontrow/console/src/helpers/api-items'
import {Routes} from '@frontrow/console/src/routers/routes'

type Props = {
  error: string | undefined | null
  createItem: (item: ItemParamsT) => Promise<number | undefined | null>
  storeCategoryVariations: Array<StoreCategoryVariationT>
}

function CreateItem(props: Props): React.ReactElement {
  const {error, createItem, storeCategoryVariations} = props
  const navigate = useNavigate()
  const errorNode = error !== null && error !== undefined ? <ErrorAlert>{error}</ErrorAlert> : null

  const onSubmit = (
    name: string,
    category: string,
    storeCategory: StoreCategoryT,
    price: number,
    isHidden: boolean,
    minGrade: number,
    maxGrade: number
  ) => {
    createItem({
      name,
      category,
      storeCategory,
      price,
      isHidden,
      minGrade,
      maxGrade
    }).then(itemId => {
      if (!isNaN(itemId!) && itemId !== null && itemId !== undefined) {
        navigate(Routes.items.itemEdit(itemId))
      }
    })
  }

  return (
    <div>
      <H1>Create Item</H1>
      <Link href={Routes.items.items()} reactRouter>
        Back
      </Link>
      {errorNode}
      <Form
        name=""
        locizeKey=""
        category=""
        storeCategory="accessories"
        price={0}
        isHidden={false}
        minGrade={0}
        maxGrade={12}
        onSubmit={onSubmit}
        storeCategoryVariations={storeCategoryVariations}
      />
    </div>
  )
}

export default CreateItem
